export const LOCAL_STORAGE_TENANT_ID_KEY = 'tenantId';
